export default __webpack_public_path__ + "static/media/fridayoffer.38b65b6d.png";